export default {
  "pl": {
    word: "{n} {word}",
  },
  "validation": {
    alpha: "{_field_} にはアルファベットのみ",
    alpha_num: "{_field_} には英数字のみ",
    alpha_dash: "{_field_} には英数字、ダッシュ、アンダーバーのみ",
    alpha_spaces: "{_field_} には英数字、スペースのみ",
    between: "{_field_} は {min} から{max}の間でお願いします",
    confirmed: "{_field_} の確認が取れません",
    digits: "{_field_} は {length} 桁を含む正確な数値でお願いします",
    dimensions: "{_field_} は{width} pixels × {height} pixelsでお願いします",
    email: "{_field_} には有効なメールアドレスでお願いします",
    excluded: "{_field_} は有効な値ではありません",
    ext: "{_field_} は有効なファイルではありません",
    image: "{_field_} は画像でお願いします",
    integer: "{_field_} は整数でお願いします",
    length: "{_field_} の長さは {length} でお願いします",
    max_value: "{_field_} は {max} 以下でお願いします",
    max: "{_field_} の文字数は {length} 文字以内でお願いします",
    mimes: "{_field_} は有効なファイルタイプでお願いします",
    min_value: "{_field_} は{min} 以上が必要です",
    min: "{_field_} は {length} 文字以上が必要です",
    numeric: "{_field_} には数字のみを入力できます",
    oneOf: "{_field_} は有効な値ではありません",
    regex: "{_field_} は無効なフォーマットです",
    required_if: "{_field_} は必須項目です",
    required: "{_field_} は必須項目です",
    size: "{_field_} のサイズは {size}KB以下でお願いします",
    credit_card: "{_field_} は有効なカード番号でお願いします",
    required_select: "{_field_} は必須項目です",
  },
  "notificationsText": {
    liked: "{screenName} があなたの投稿を気に入っています",
    followed: "{screenName} があなたをフォローしました",
    subscribed: "{screenName} が  {price}で購入しました",
    upgradeSubscription: "{screenName} がサブスクをアップグレードしました。サブスクレベルは {price}です",
    soldPost: "{screenName} があなたの投稿を {price}で購入しました",
    soldAttachment: "{screenName} があなたの投稿を {price}で購入しました",
  },
  "Alabama": "アラバマ",
  "Alaska": "アラスカ",
  "American Samoa": "サモア",
  "Arizona": "アリゾナ",
  "Arkansas": "アーカンソー",
  "California": "カリフォルニア",
  "Colorado": "コロラド",
  "Connecticut": "コネチカット",
  "Delaware": "デラウェア",
  "District of Columbia": "コロンビア特別区",
  "Florida": "フロリダ",
  "Georgia": "ジョージア",
  "Guam": "グアム",
  "Hawaii": "ハワイ",
  "Idaho": "アイダホ",
  "Illinois": "イリノイ",
  "Indiana": "インディアナ",
  "Iowa": "アイオワ",
  "Kansas": "カンザス",
  "Kentucky": "ケンタッキー",
  "Louisiana": "ルイジアナ",
  "Maine": "メイン",
  "Maryland": "メリーランド",
  "Massachusetts": "マサチューセッツ",
  "Michigan": "ミシガン",
  "Minnesota": "ミネソタ",
  "Mississippi": "ミシシッピ",
  "Missouri": "ミズーリ",
  "Montana": "モンタナ",
  "Nebraska": "ネブラスカ",
  "Nevada": "ネバダ",
  "New Hampshire": "ニューハンプシャー",
  "New Jersey": "ニュージャージー",
  "New Mexico": "ニューメキシコ",
  "New York": "ニューヨーク",
  "North Carolina": "ノースカロライナ",
  "North Dakota": "ノースダコタ",
  "Northern Mariana Islands": "北マリアナ諸島",
  "Ohio": "オハイオ",
  "Oklahoma": "オクラホマ",
  "Oregon": "オレゴン",
  "Pennsylvania": "ペンシルベニア",
  "Puerto Rico": "プエルトリコ",
  "Rhode Island": "ロードアイランド",
  "South Carolina": "サウスカロライナ",
  "South Dakota": "サウスダコタ",
  "Tennessee": "テネシー",
  "Texas": "テキサス",
  "U.S. Minor Outlying Islands": "合衆国領有小島",
  "U.S. Virgin Islands": "アメリカ領ヴァージン諸島",
  "Utah": "ユタ",
  "Vermont": "バーモント",
  "Virginia": "バージニア",
  "Washington": "ワシントン",
  "West Virginia": "ウェストバージニア",
  "Wisconsin": "ウィスコンシン",
  "Wyoming": "ワイオミング",
  "United States of America": "アメリカ合衆国",
  "Canada": "カナダ",
  "Afghanistan": "アフガニスタン",
  "Algeria": "アルジェリア",
  "Samoa": "サモア",
  "Andorra": "アンドラ",
  "Angola": "アンゴラ",
  "Anguilla": "アンギラ",
  "Antarctica": "南極",
  "Antigua and Barbuda": "アンティグアバーブーダ",
  "Argentina": "アルゼンチン",
  "Armenia": "アルメニア",
  "Aruba": "アルバ",
  "Australia": "オーストラリア",
  "Austria": "オーストリア",
  "Azerbaijan": "アゼルバイジャン",
  "Bahamas": "バハマ",
  "Bahrain": "バーレーン",
  "Bangladesh": "バングラデシュ",
  "Barbados": "バルバドス",
  "Belgium": "ベルギー",
  "Belize": "ベリーズ",
  "Benin": "ベニン",
  "Bermuda": "バミューダ",
  "Bhutan": "ブータン",
  "Bolivia, Plurinational State of": "ボリビア、多国籍国家",
  "Bonaire, Sint Eustatius and Saba": "ボネール、シントユースタティウス島とサバ島",
  "Botswana": "ボツワナ",
  "Bouvet Island": "ブーベ島",
  "Brazil": "ブラジル",
  "British Indian Ocean Territory": "英領インド洋地域",
  "Brunei Darussalam": "ブルネイダルサラーム",
  "Burkina Faso": "ブルキナファソ",
  "Cabo Verde": "カーボベルデ",
  "Cambodia": "カンボジア",
  "Cameroon": "カメルーン",
  "Cayman Islands": "ケイマン諸島",
  "Chad": "チャド",
  "Chile": "チリ",
  "China": "中国",
  "Christmas Island": "クリスマス島",
  "Cocos (Keeling) Islands": "ココス（キーリング）諸島",
  "Colombia": "コロンビア",
  "Comoros": "コモロ",
  "Congo": "コンゴ",
  "Cook Islands": "クック諸島",
  "Costa Rica": "コスタリカ",
  "Curaçao": "キュラソー",
  "Cyprus": "キプロス",
  "Czechia": "チェコ",
  "Denmark": "デンマーク",
  "Djibouti": "ジブチ",
  "Dominica": "ドミニカ",
  "Dominican Republic": "ドミニカ共和国",
  "Ecuador": "エクアドル",
  "Egypt": "エジプト",
  "El Salvador": "エルサルバドル",
  "Equatorial Guinea": "赤道ギニア",
  "Eritrea": "エリトリア",
  "Estonia": "エストニア",
  "Eswatini": "エスワティニ",
  "Ethiopia": "エチオピア",
  "Falkland Islands (Malvinas)": "フォークランド諸島（マルビナス）",
  "Faroe Islands": "フェロー諸島",
  "Fiji": "フィジー",
  "Finland": "フィンランド",
  "France": "フランス",
  "French Guiana": "仏領ギアナ",
  "French Polynesia": "フランス領ポリネシア",
  "French Southern Territories": "フランス領南方南方領土",
  "Gabon": "ガボン",
  "Gambia": "ガンビア",
  "Germany": "ドイツ",
  "Ghana": "ガーナ",
  "Gibraltar": "ジブラルタル",
  "Greece": "ギリシャ",
  "Greenland": "グリーンランド",
  "Grenada": "グレナダ",
  "Guadeloupe": "グアドループ",
  "グアム": "グアム",
  "Guatemala": "グアテマラ",
  "Guernsey": "ガーンジー",
  "Guinea": "ギニア",
  "Guinea-Bissau": "ギニアビサウ",
  "Guyana": "ガイアナ",
  "Haiti": "ハイチ",
  "Heard Island and McDonald Islands": "ハード島とマクドナルド諸島",
  "Holy See": "バチカン",
  "Honduras": "ホンジュラス",
  "Hong Kong": "香港",
  "Hungary": "ハンガリー",
  "Iceland": "アイスランド",
  "India": "インド",
  "Indonesia": "インドネシア",
  "Ireland": "アイルランド",
  "Isle of Man": "マン島",
  "Israel": "イスラエル",
  "Italy": "イタリア",
  "Jamaica": "ジャマイカ",
  "Japan": "日本",
  "Jersey": "ジャージー",
  "Jordan": "ジョーダン",
  "Kazakhstan": "カザフスタン",
  "Kenya": "ケニア",
  "Kiribati": "キリバス",
  "Korea, Republic of": "大韓民国",
  "Kuwait": "クウェート",
  "Kyrgyzstan": "キルギスタン",
  "Lao People's Democratic Republic": "ラオス人民民主共和国",
  "Latvia": "ラトビア",
  "Lesotho": "レソト",
  "Libya": "リビア",
  "Liechtenstein": "リヒテンシュタイン",
  "Lithuania": "リトアニア",
  "Luxembourg": "ルクセンブルグ",
  "Macao": "マカオ",
  "Madagascar": "マダガスカル",
  "Malawi": "マラウイ",
  "Malaysia": "マレーシア",
  "Maldives": "モルディブ",
  "Malta": "マルタ",
  "Marshall Islands": "マーシャル諸島",
  "Martinique": "マルティニーク",
  "Mauritania": "モーリタニア",
  "Mauritius": "モーリシャス",
  "Mayotte": "マヨット",
  "Mexico": "メキシコ",
  "Micronesia, Federated States of": "ミクロネシア連邦",
  "Monaco": "モナコ",
  "Mongolia": "モンゴル",
  "Montserrat": "モントセラト",
  "Morocco": "モロッコ",
  "Mozambique": "モザンビーク",
  "Myanmar": "ミャンマー",
  "Namibia": "ナミビア",
  "Nauru": "ナウル",
  "Nepal": "ネパール",
  "Netherlands": "オランダ",
  "New Caledonia": "ニューカレドニア",
  "New Zealand": "ニュージーランド",
  "Niger": "ニジェール",
  "Nigeria": "ナイジェリア",
  "Niue": "ニウエ",
  "Norfolk Island": "ノーフォーク島",
  "Norway": "ノルウェー",
  "Oman": "オマーン",
  "Pakistan": "パキスタン",
  "Palau": "パラオ",
  "Palestine, State of": "パレスチナ、州",
  "Panama": "パナマ",
  "Papua New Guinea": "パプアニューギニア",
  "Paraguay": "パラグアイ",
  "Peru": "ペルー",
  "Philippines": "フィリピン",
  "Pitcairn": "ピトケアン",
  "Poland": "ポーランド",
  "Portugal": "ポルトガル",
  "Qatar": "カタール",
  "Russian Federation": "ロシア連邦",
  "Rwanda": "ルワンダ",
  "Réunion": "レユニオン",
  "Saint Barthélemy": "サンバルテルミー",
  "Saint Helena, Ascension and Tristan da Cunha": "セントヘレナ、アセンションとトリスタンダクーニャ",
  "Saint Kitts and Nevis": "セントクリストファー・ネイビス",
  "Saint Lucia": "セントルシア",
  "Saint Martin, (French part)": "サンマルタン、（フランスの部分）",
  "Saint Pierre and Miquelon": "サンピエール島とミクロン島",
  "Saint Vincent and the Grenadines": "セントビンセントおよびグレナディーン諸島",
  "San Marino": "サンマリノ",
  "Sao Tome and Principe": "サントメ・プリンシペ",
  "Saudi Arabia": "サウジアラビア",
  "Senegal": "セネガル",
  "Seychelles": "セイシェル",
  "Sierra Leone": "シエラレオネ",
  "Singapore": "シンガポール",
  "Sint Maarten, (Dutch part)": "シントマールテン、（オランダの部分）",
  "Slovakia": "スロバキア",
  "Slovenia": "スロベニア",
  "Solomon Islands": "ソロモン諸島",
  "South Africa": "南アフリカ",
  "South Georgia and the South Sandwich Islands": "サウスジョージアとサウスサンドイッチ諸島",
  "South Sudan": "南スーダン",
  "Spain": "スペイン",
  "Sri Lanka": "スリランカ",
  "Suriname": "スリナム",
  "Svalbard and Jan Mayen": "スバールバル諸島およびヤンマイエン",
  "Sweden": "スウェーデン",
  "Switzerland": "スイス",
  "Taiwan, Province of China": "台湾、中国省",
  "Tajikistan": "タジキスタン",
  "Tanzania, United Republic of": "タンザニア、連合共和国",
  "Thailand": "タイ",
  "Timor-Leste": "東ティモール",
  "Togo": "トーゴ",
  "Tokelau": "トケラウ",
  "Tonga": "トンガ",
  "Trinidad and Tobago": "トリニダード・トバゴ",
  "Tunisia": "チュニジア",
  "Turkey": "トルコ",
  "Turkmenistan": "トルクメニスタン",
  "Turks and Caicos Islands": "タークス・カイコス諸島",
  "Tuvalu": "ツバル",
  "Uganda": "ウガンダ",
  "United Arab Emirates": "アラブ首長国連邦",
  "United Kingdom of Great Britain and Northern Ireland": "グレートブリテンおよび北アイルランド連合王国",
  "United States Minor Outlying Islands": "合衆国領有小島",
  "Uruguay": "ウルグアイ",
  "Uzbekistan": "ウズベキスタン",
  "Vanuatu": "バヌアツ",
  "Venezuela, Bolivarian Republic of": "ベネズエラ、ボリバル共和国",
  "Viet Nam": "ベトナム",
  "Virgin Islands, British": "英領バージン諸島",
  "Virgin Islands, U.S.": "米領バージン諸島",
  "Wallis and Futuna": "ウォリス・フツナ",
  "Western Sahara": "西サハラ",
  "Zambia": "ザンビア",
  "Åland Islands": "オーランド諸島",
  "Live": "ライブ",
  "Bio": "個人情報",
  "Get access to this media": "このコンテンツにアクセスする",
  "Your {0}": "あなたの {0}",
  "{0} call": "{0} のコール",
  "follower": "フォロワー",
  "subscriber": "定期購読者",
  "user": "ユーザー",
  "There are no posts yet.": "投稿はありません.",
  "Posts": "投稿",
  "Payout information": "お支払い情報",
  "Show": "確認",
  "Email": "メール",
  "Verification code": "確認コード",
  "This is the monthly subscription price for your page": "サブスクリプション料金",
  "Here are different monthly subscription levels for your page": "サブスクリプション料金レベル",
  "Get a new code in {timer} seconds": "新しいコードを {timer} 秒で取得します",
  "Unlock for {price}": " {price}でロック解除",
  "Download{0}": "ダウンロード{0}",
  "Unlock{0}": "ロック解除{0}",
  "Unfollow {0}?": " {0}のフォローを外しますか?",
  "{0} needs to agree to video chat.": "{0} がライブチャットに同意する必要があります.",
  "{0} asks for video chat": "{0} がライブチャットを要求しています",
  "Call for {0} per min": " {0} と1分あたりの通話料金",
  "Paid call{0}": "有料通話{0}",
  "from your {0}": " {0}から",
  "The charge on your credit card bill will appear as {0} on your credit card statement":
    "クレジットカードの請求書に記載されている料金は、明細書に {0} と表示されます",
  "loginPolicy": "新規登録をすることで {termsOfUse} に同意し、 {privacyPolicy}を理解したことと承認します",
  "Rebill from card **** {0} every month": "毎月、カード **** {0} に再請求されます",
  "Last rebill {0}": "{0}の最終請求です",
  "Expires {0}": " {0}は期限切れです",
  "Rebills {0}": " {0}の再請求",
  "Expired on {0}": "消費期限は {0}です",
  "Cancel rebill of {amount} subscription to {screenName}?":
    "{screenName} への {amount} サブスクリプションの再請求をキャンセルしますか？",
  "Content will be available untill {0}.": "このコンテンツは {0}まで有効です",
  "{0} once": "{0} 回",
  "{0}/mo": "{0}/月",
  "preview_set_description": "コンテンツを公開し {icon} 購読者数を増やしましょう",
  "{0} Cr": "{0}円",
  "{0} isn't following anyone yet": "{0} はまだ誰もフォローしていません",
  "{0} doesn't have followers yet": "{0} にはまだフォロワーがいません",
  "sensitive_content_agreement": "私は18歳以上であり {sensitiveContentAgreement}に署名します",
  "{0} items": "{0} のアイテム",
  "Show all {0}": " {0}の全てを表示",
  "{0} and higher": "{0} 以上",
  "netbillingTcAgree": "個人情報を送信することで、私が18歳以上であり {termsOfUse}に同意したことを証明します",
  "netbillingAddCardDescription": "全ての請求は、クレジットカードの利用明細書に “{companyName}”と表示されます",
  "Scheduled for {0}": " {0}の予定です",
  "credit_card_explanation": "ご購入されると、カードから自動的に引き落とされます。決済はいつでも変更・削除できます",
  "Purchased for {0}": " {0}を購入しました",
  "Locked for {0}": " {0}はロックされています",
  "{0} has sent you a message": "{0} があなたにメッセージを送りました",
  "securityReasonsInfoChange": "セキュリティの為、管理者がクリエイターの申請を承認する必要があります",
  "Payee information": "振込先情報",
  "Payee setup": "受取人設定",
  "profileEmptyTitle": "どういたしまして!",
  "profileEmptyDescription": "始めましょう",
  "Last visited {0}": " 最後に訪問したのは{0}です",
  "Processing...": "処理中...",
  "{0} started live video": "{0} はライブチャットを開始",
  "Close": "閉じる",
  "Sign up": "会員登録",
  "Log in": "ログイン",
  "it's better to have": "作成した方が良い",
  "1k paying fans than": "千の有料ファンよりも",
  "100k passive ones": "10万の視聴者",
  "Create and get paid": "コンテンツを作成し報酬を得る",
  "You need sign up to continue": "続けるには会員登録をして下さい",
  "Already have an account?": "会員登録はお済みですか?",
  "Log in.": "ログイン",
  "Message": "メッセージ",
  "Following": "フォローする",
  "Unfollow": "フォローを外す",
  "Cancel": "キャンセル",
  "DMCA": "著作権法",
  "Call ended": "通話終了",
  "Connecting...": "接続中...",
  "Are you sure you want to close this window?": "このウィンドウを閉じてもよろしいですか？",
  "Closing this dialog registration process will be stopped.": "このダイアログを閉じると登録作業は停止されます",
  "You can always continue, just use login form.": "いつでも続行できます。ログインフォームを使用して下さい",
  "No, continue registration": "いいえ、登録を続行します",
  "Oops! It seems that there isn’t enough money on your balance.": "残高が不足しているようです",
  "Add money": "お金を追加",
  "PayPal": "PayPal",
  "PayPal email address": "PayPalのメールアドレス",
  "Add files": "ファイルを追加",
  "or drag and drop files": "またはファイルをドロップする",
  "Add cover": "カバーの追加",
  "Schedule post": "投稿のスケジュール",
  "New post": "新規投稿",
  "Edit post": "投稿の編集",
  "Going live": "ライブ配信",
  "Link to your live chat room:": "ライブチャットのリンク:",
  "Go live": "ライブを観る",
  "Link copied": "コピーされたリンク",
  "Get the code": "コードを取得",
  "Continue": "続ける",
  "Phone number": "電話番号",
  "Deleted post": "削除された投稿",
  "Unlock": "ロック解除",
  "{0} for {1}": " {1}のための{0}",
  "Not purchased yet": "未購入",
  "Location": "ロケーション",
  "Website": "ウェブサイト",
  "Facebook": "Facebook",
  "Twitter": "Twitter",
  "Instagram": "Instagram",
  "TikTok": "TikTok",
  "YouTube": "YouTube",
  "Snapchat": "Snapchat",
  "Patreon": "Patreon",
  "OnlyFans": "OnlyFans",
  "Report": "レポート",
  "Edit": "編集",
  "Delete": "削除",
  "Home": "ホーム",
  "Profile": "プロフィール",
  "Messages": "メッサージ",
  "Notifications": "通知",
  "More": "詳しくは",
  "Undo report": "元に戻す",
  "This file is broken.": "このファイルは壊れています",
  "It will not be displayed to the recipient.": "受信者には表示されません",
  "Please wait.": "お待ちください",
  "Your file is uploading...": "ファイルをアップロード中です...",
  "This can take a few minutes.": "これには数分かかることがあります",
  "Password": "パスワード",
  "Invalid verification code": "認証コードが無効です",
  "Refund Policy": "返金ポリシー",
  "Privacy Policy": "プライバシーポリシー",
  "Cookie Policy": "Cookieポリシー",
  "Security Policy": "セキュリティポリシー",
  "18 U.S.C. 2257 Compliance": "18U.S.C。2257コンプライアンス",
  "Terms of Use": "利用規約",
  "Balance history": "残高履歴",
  "+ Add money": "+ お金を追加する",
  "Balance": "収支",
  "Payout": "報酬",
  "E-mail notifications": "メール通知",
  "Clear": "リセット",
  "Save": "保存",
  "Incoming messages": "受信メッサージ",
  "Other": "その他",
  "Details": "詳細",
  "Sign up with email": "メールで会員登録",
  "Follow": "フォローする",
  "Processing error": "処理エラー",
  "Not published": "非公開",
  "Sensitive content": "機密事項",
  "Photo or scan of your ID": "身分証のスキャンまたは撮影",
  "Verify that you're over 18": "18歳以上であることを証明する",
  "We use your ID to verify your personal information. We do not publish or distribute your images.":
    "お客様の身分証を確認したことで、お客様の個人情報を外部に漏洩することは一切ございません",
  "Make sure that all information from the photo is easy to read.": "情報が分かるように明瞭な画像を使用して下さい",
  "Your photo with ID": "身分証の画像",
  "First name": "名前",
  "Last name": "苗字",
  "Delete post?": "投稿を削除しますか?",
  "This post will no longer be available for users who bought it.": "この投稿は購入者に公開されません",
  "Keep the post?": "投稿を保存しますか?",
  "Keep": "継続する",
  "Content will be saved and you can return to editing at any time.": "保存されたコンテンツはいつでも編集可能です",
  "Save draft": "下書きを保存",
  "Delete draft": "下書きを削除",
  "Load more": "読み込む",
  "Message price changed": "メッセージの料金が変更されました",
  "Send message for {0}": " {0}にメッセージを送信する",
  "Account settings": "アカウント設定",
  "Subscription management": "サブスク管理",
  "Become Creator": "クリエーターになる",
  "Subscription levels": "サブスクレベル",
  "Price settings": "価格設定",
  "Payment card": "カード決済",
  "Invite friends": "友達を招待する",
  "Support": "サポート",
  "Terms & Policies": "利用規約",
  "Logout": "ログアウト",
  "Change password": "パスワードの変更",
  "Decline": "辞退する",
  "First, what will your page be about?": "まずは何をテーマに投稿しますか?",
  "Answer": "回答",
  "Comment sent": "コメント送信",
  "Comment": "コメント",
  "Create Post": "投稿の作成",
  "Create post": "投稿の作成",
  "Create event": "イベントの作成",
  "Add Cover": "カバーの追加",
  "Link to event": "イベントのリンク",
  "Users will get access to this meeting link after the purchase":
    "購入後のユーザーは、このミーティングリンクにアクセスできます",
  "Validating...": "検証中...",
  "The link field must be a valid url": "リンクは有効なURLでお願いします",
  "Bank": "銀行",
  "Name on account": "口座名義",
  "Bank name": "銀行名",
  "Bank address": "銀行の住所",
  "Bank account number": "口座番号",
  "Bank routing": "送金銀行",
  "Account details": "口座の詳細",
  "Checking or savings account, etc.": "当座預金または普通預金口座など",
  "Caption": "サブタイトル",
  "Post now": "今すぐ投稿",
  "Date": "日付",
  "Time": "時間",
  "Contact us": "お問い合わせ",
  "Change card": "カードの変更",
  "Add": "追加",
  "Thank you for your purchase": "ご購入ありがとうございます",
  "Accessibility": "利用しやすさ",
  "Make it free": "無料",
  "Post is free now": "今すぐ無料投稿",
  "Available for everyone": "誰でも利用可能",
  "Disable access by subscription": "サブスクリプションを無効にする",
  "Disable one-time buy": "スポット購入を無効にする",
  "Access for subscribers": "購読者へのアクセル",
  "One-time buy": "スポット購入",
  "hr": "時間",
  "min": "分",
  "Incoming": "着信",
  "Outgoing": "発信",
  "sec": "秒",
  "User deleted": "削除されたユーザー",
  "Followers": "フォロワー",
  "You aren't following anyone yet": "あなたはまだ誰もフォローしていません",
  "You don't have followers yet": "フォロワーはまだいません",
  "Your account was successfully sent for verification": "アカウント申請は送信されました",
  "We will email you when you are approved. For now, you can prepare content on your page. When verification and your application is approved, subscribers will be able to purchase it.":
    "申請が承認され次第、メールでお知らせ致します。申請が承認されると、あなたのファンが購読できるようになります。只今でもコンテンツの準備は可能です。",
  "Go to profile": "プロフィールを見る",
  "Age": "年齢",
  "Attached": "添付",
  "Not attached": "添付していません",
  "Payout system": "お支払い",
  "Currency": "通貨",
  "Choose payout system": "お支払いを選択",
  "Choose currency": "通貨を選択",
  "Get access to this post": "この投稿にアクセス",
  "Unlock for": "ロック解除",
  "or": "または",
  "Please click subscribe below": "以下の購読をクリックして下さい",
  "The following subscription will give you access to this Creator's premium content":
    "以下の購読で、クリエイターのプレミアムコンテンツにアクセスできます",
  "Missed": "失敗",
  "Cancelled": "キャンセルされました",
  "Declined": "辞退しました",
  "Select previews": "プレビューを選択",
  "Discover": "発見",
  "This page may contain potentially sensitive content":
    "このページには潜在的にアダルトなコンテンツが含まれている可能性があります",
  "Do you still want to view it?": "続けてご覧になりますか？",
  "Yes": "はい",
  "No": "いいえ",
  "You have previously saved draft.": "以前に保存した下書きです",
  "Do you want to use it or delete and start from scratch?": "やり直しますか?",
  "Use draft": "下書きを使う",
  "From scratch": "初めから",
  "Forgot password?": "パスワードをお忘れですか?",
  "Incorrect password or email": "パスワードまたはメールアドレスが正しくありません",
  "Your balance": "残高",
  "Don’t show anymore": "表示しない",
  "We sent you a 6-digit code": "6桁のコードを送信しました",
  "Check your spam": "スパムをチェックして下さい",
  "Please enter the verification code we sent to {0}": " {0}に送信した確認コードを入力して下さい",
  "Get a new code in {0} seconds": "新しいコードを {0}秒で取得します",
  "Get a new code": "新しいコードを取得します",
  "Done": "完了",
  "You can unfollow only from the 'Following' menu. To cancel an active subscription level go to the 'Subscription management' menu.":
    "フォロー解除はフォローメニューからのみ可能です。有効なサブスクレベルをキャンセルするにはサブスク管理メニューに進んで下さい",
  "By clicking the Follow button you will only get access to the creator's free content, to access additional content you can subscribe.":
    "フォローするとクリエイターの無料コンテンツにアクセスできます。追加のコンテンツにアクセスするには、月間購読（サブスクリプション）または単体購読（スポット）が必要です",
  "Subscriptions": "サブスクリプション",
  "Edit profile": "プロフィール編集",
  "Online": "オンライン",
  "Find someone to follow": "フォローする人を見つける",
  "Feed": "フィード",
  "Social media accounts": "SNSアカウント",
  "Name": "名前",
  "Username": "ユーザーネーム",
  "Names can only contain letters, numbers, dashes, dots, and underscores.":
    "名前には文字、数字、ダッシュ、ドット、アンダーバーが使用できます",
  "You receive {0}% lifetime commission on all income earned by any user who joins the platform via your referral link.":
    " あなたの紹介で参加したユーザーの得た収入に対して {0}% の紹介料が、あなたの権利として発生します",
  "1. Copy and share the link with the person who will make money on the platform":
    "1. リンクをコピーして、お友達と共有しましょう",
  "2. Wait until that person signs up using your referral link":
    "2. お友達があなたからの紹介リンクを使って会員登録する",
  "3. Start getting {0}% from all income made by the person you invited":
    "3. 紹介されたお友達が得た報酬の {0}% を紹介料として、毎回取得する",
  "Share link": "共有リンク",
  "Link copied to clipboard": "クリップボードにコピーされたリンク",
  "Connection lost": "接続が切れました",
  "Switching to video chat...": "ライブチャットに切り替えます...",
  "Call ended due to connection error.": "接続エラーにより通話が終了しました",
  "Call back": "かけ直す",
  "Free": "無料",
  "Level": "レベル",
  "Price": "料金",
  "You": "あなた",
  "Photo": "画像",
  "Video": "ビデオ",
  "Call": "コール",
  "Billing details": "請求の詳細",
  "Country": "国",
  "Address": "住所",
  "City": "都市",
  "State": "状態",
  "Select state": "状態を選択",
  "Zip code": "Zip コード",
  "This field is required": "この項目は必須です",
  "Save this card for future purchases": "このカードを今後の購入用に保存する",
  "This card will be used for subscription renewal and other purchases":
    "このカードはサブスクの更新やそのほかの鉱毒に使用されます",
  "Your data is safe.": "あなたのデータは安全です",
  "Purchase": "購入",
  "Subscribe": "購読",
  "Card details": "カード詳細",
  "Card Number": "カード番号",
  "Expiration Date": "有効期限",
  "CVV code": "CVV コード",
  "Name on card": "カード名義",
  "Forgot password": "パスワードをお忘れですか？",
  "Please enter your email address and we will send you instructions to reset password.":
    "メールアドレスを入力して下さい。パスワードの再設定方法を送信致します",
  "Subscribers": "定期購読者",
  "All": "全て",
  "Select:": "選択:",
  "Subscribers selected": "選択された定期購読者",
  "Sign up & log in": "会員登録&ログイン",
  "We are real .": "私は本人です。",
  "We exist .": "私はロボットではありません。",
  "Subscription": "サブスクリプション",
  "per month": "月額",
  "Monetize each engagement with your subscribers through: ": "サブスクリプションで収益化する:",
  "monthly subscription": "月額制",
  "paid posts": "有料記事",
  "text messages": "テキストメッセージ",
  "private audio and video calls": "プライベートビデオコール",
  "Next": "次へ",
  "Set password": "パスワードの設定",
  "Password field is empty": "パスワードが入力されていません",
  "Password has been changed": "パスワードが変更されました",
  "Your data is secured.": "あなたのデータは保護されています",
  "Personal information": "個人情報",
  "Fill in your personal information to accept payments": "報酬を受けるために個人情報を入力して下さい",
  "Payment Card": "決済カード",
  "Remove card": "カードの削除",
  "Your payment card is successfully linked": "決済カードが登録されました",
  "No payment card to show": "表示する決済カードがありません",
  "Once you make your first purchase and save the card, it will appear on this page":
    "初回購入時にカードを保存すると、このページに表示されます",
  "Enable incoming calls": "着信を受ける",
  "Price per minute of call": "1分あたりの通話料金",
  "Price per incoming message": "一件あたりの着信メッサージ料金",
  "Price per incoming media message": "一件あたりのメディアメッセージ料金",
  "Edit subscription level": "サブスクレベルの編集",
  "All current members will be unsubscribed from paid access to your page.":
    "あなたのページへの有料アクセスが停止されます。",
  "Price for new subscribers. Сurrent subscribers will be unsubscribed at the end of the month":
    "新規購読者の料金です。購読中の会員は今月末に解約されます。",
  "No levels available": "利用可能なレベルはありません",
  "You have not set up any paid subscriptions for your page": "有料会員の設定をまだしていません",
  "Setup": "設定",
  "Price per month": "月額料金",
  "Tell what kind of content your fans get buying this subscription level access":
    "このサブスクレベルを購入すると、あなたのファンにどのようなサービスがあるのかを説明して下さい",
  "It’s empty here.": "何もありません",
  "Let’s find people to subscribe!": "定期購読者を見つけましょう",
  "Cancel rebill": "継続をキャンセル",
  "Rebill canceled": "再請求をキャンセルしました",
  "Content will be available until {0}.": "このコンテンツは{0}までご利用出来ます",
  "End": "終了",
  "Exit": "退出",
  "We will inform your followers that you has started broadcasting": "ライブチャットの開始をフォロワーにお知らせします",
  "Do you really want to end video live?": "ライブチャットを終了しますか?",
  "End now": "終了",
  "Profile themes": "プロフィールのテーマ",
  "Add subscription level": "サブスクレベルの追加",
  "Agree": "同意",
  "Refuse": "拒否",
  "Hide": "表示しない",
  "New mass message": "新しいメッセージ",
  "Open link": "リンク",
  "link to event": "イベントリンク",
  "or sign up with": "または会員登録",
  "Confirm email": "メール確認",
  "To keep your data safe and protect the access to your account and password recovery please enter your email.":
    "アカウントデータとパスワード保護の為メールアドレスを入力して下さい",
  "Available": "ご利用可能です",
  "We’re waiting for your payment": "お支払いをお待ちしています",
  "Processing request...": "リクエスト中...",
  "1 min left! Please refill": "残り1分です。再度購入をお願いします",
  "Post": "投稿",
  "Filter by themes": "テーマフィルター",
  "Verification completed": "認証完了",
  "Verification failed": "認証失敗",
  "Go to our site and enter the verification code from email we sent.": "送信された認証コードを入力して下さい",
  "Removing card": "カードの削除",
  "Themes": "テーマ",
  "Publish": "発行",
  "Cost: free": "料金: 無料",
  "Sign up or log in": "会員登録またはログイン",
  "or log in with": "またはログイン",
  "more": "もっと見る",
  "Choose subscription": "サブスクリプションを選ぶ",
  "per min": "1分あたり",
  "Refund": "返金",
  "Deposit": "デポジット",
  "Attachment": "添付ファイル",
  "Paid message": "有料メッセージ",
  "Referral bonus": "紹介料",
  "Oops! Your feed is empty": "フィードが空です",
  "Try to follow creators to build your own feed": "クリエイターをフォローして自分のフィードを作成しましょう",
  "Select recipients": "受信者の選択",
  "recipient": "受信者",
  "Marked as important": "マークする",
  "Marked as common": "マークする",
  "This browser does not support WebRTC": "このブラウザはwebRTCをサポートしていません",
  "Send for verification": "認証送信",
  "agreement terms": "契約条件",
  "And confirm that I am over 18": "私が18歳以上であることを確認する",
  "Your paid posts become available to other users once your account is verified.":
    "アカウントの認証が済み次第、有料コンテンツが利用可能となります",
  "Your referrals": "あなたの紹介",
  "new message": "新しいメッセージ",
  "page_complaints_annotation-1":
    "We are doing our best so you will enjoy the content provided. If, in any case, you have a complaint, please let us know.",
  "page_complaints_annotation-2": "All complaints will be reviewed and resolved within seven business days.",
  "Statements": "Statements",
  "No earnings yet": "No earnings yet",
  "Attachments": "Attachments",
  "Tips": "Tips",
  "Earnings:": "Earnings:",
  "Net": "Net",
  "Gross": "Gross",
  "Fees:": "Fees:",
  "Platform fee": "Platform fee",
  "add_money_description":
    "The money added to the balance can be used to send a paid message, have a call with the creator or tip in messages, or live.",
  "user_upgrade_subscription_discount_description":
    "When upgrading your subscription, you will be charged now the difference between subscriptions. At the end of the 1 month subscription cycle, you will be charged the full subscription amount for all recurring months.",
  "for_the_first_month": "for the first month",
};
